import { useRef } from 'react';

function useContainerRef() {
  const containerRef = useRef<HTMLDivElement>(null);
  const getContainer: any = () => containerRef.current;
  return { containerRef, getContainer };
}

export default useContainerRef;
